import { MediaConnectionBitrateTest } from '@twilio/rtc-diagnostics';
import { Device, PreflightTest, RTCSample } from '@twilio/voice-sdk';
import { DiagnosticError } from '@twilio/rtc-diagnostics';
import { DNSLookupTestResults } from './NetworkTestWidget/Tests/Tests.model';

export type NetworkTestName = 'Bitrate Test' | 'Preflight Test';

declare global {
  interface RTCIceServer {
    url: string;
  }
}

declare module '@twilio/voice-sdk' {
  // eslint-disable-next-line
  namespace Device {
    interface Error {
      code?: number;
      message?: string;
      error?: any;
      hasConnected: boolean;
      latestSample: RTCSample;
    }
  }
}

export interface DNSlookupError {
  errorCode?: string;
  errorDescription?: string;
}
export interface TestResults {
  edge: Edge;
  results: {
    bitrate?: MediaConnectionBitrateTest.Report;
    preflight?: PreflightTest.Report;
    dnsLookupTest?: DNSLookupTestResults;
  };
  errors: {
    bitrate?: DiagnosticError;
    preflight?: Device.Error;
    dnsLookupTest?: DNSlookupError;
  };
}

export enum TestWarnings {
  none = '',
  warn = 'warn',
  error = 'error',
  warnTurn = 'warnTurn',
  warnTurnTCP = 'warnTurnTCP',
  warnTurnUDP = 'warnTurnUDP',
}

export type Edge =
  | 'ashburn'
  | 'dublin'
  | 'frankfurt'
  | 'roaming'
  | 'sao-paulo'
  | 'singapore'
  | 'sydney'
  | 'tokyo'
  | 'ashburn-ix'
  | 'london-ix'
  | 'frankfurt-ix'
  | 'san-jose-ix'
  | 'singapore-ix';
